"use strict";
// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// source: miimosa/common/v1/project_type.proto
Object.defineProperty(exports, "__esModule", { value: true });
exports.projectTypeToJSON = exports.projectTypeFromJSON = exports.ProjectType = void 0;
/* eslint-disable */
/** @deprecated */
exports.ProjectType = {
    /** PROJECT_TYPE_UNSPECIFIED - All */
    PROJECT_TYPE_UNSPECIFIED: "PROJECT_TYPE_UNSPECIFIED",
    /** PROJECT_TYPE_DONATION - Project::Collect::Donation */
    PROJECT_TYPE_DONATION: "PROJECT_TYPE_DONATION",
    /** PROJECT_TYPE_LENDING - Project::Collect::Lending */
    PROJECT_TYPE_LENDING: "PROJECT_TYPE_LENDING",
    UNRECOGNIZED: "UNRECOGNIZED",
};
function projectTypeFromJSON(object) {
    switch (object) {
        case 0:
        case "PROJECT_TYPE_UNSPECIFIED":
            return exports.ProjectType.PROJECT_TYPE_UNSPECIFIED;
        case 1:
        case "PROJECT_TYPE_DONATION":
            return exports.ProjectType.PROJECT_TYPE_DONATION;
        case 2:
        case "PROJECT_TYPE_LENDING":
            return exports.ProjectType.PROJECT_TYPE_LENDING;
        case -1:
        case "UNRECOGNIZED":
        default:
            return exports.ProjectType.UNRECOGNIZED;
    }
}
exports.projectTypeFromJSON = projectTypeFromJSON;
function projectTypeToJSON(object) {
    switch (object) {
        case exports.ProjectType.PROJECT_TYPE_UNSPECIFIED:
            return "PROJECT_TYPE_UNSPECIFIED";
        case exports.ProjectType.PROJECT_TYPE_DONATION:
            return "PROJECT_TYPE_DONATION";
        case exports.ProjectType.PROJECT_TYPE_LENDING:
            return "PROJECT_TYPE_LENDING";
        case exports.ProjectType.UNRECOGNIZED:
        default:
            return "UNRECOGNIZED";
    }
}
exports.projectTypeToJSON = projectTypeToJSON;
//# sourceMappingURL=project_type.js.map